import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import { BOON_VALUES_OPTIONS } from '../../../../../../constants/contactsConstants';

import CustomMenuList from './CustomMenuList';
import CustomOption from './CustomOption';

const customStyles = {
  option: (base, state) => ({
    ...base,
    backgroundColor: 'white',
    cursor: state.isFocused ? 'pointer' : 'auto',
    padding: 0,
    boxShadow: 'inset 0px -1px 0px rgba(211, 218, 230, 0.5)',
  }),
  control: (base) => ({
    ...base,
    border: '1px solid #BFBFBF !important',
    borderRadius: '4px',
    boxShadow: 'none',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 2,
    margin: 0,
    borderRadius: 4,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#C2C2C2',
    fontSize: 14,
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    border: 0,
    overflowY: 'visible',
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: 14,
    color: '#444444',
  }),
};

const MappingSelect = ({ value, onChange, handleAddCustomField, selectedOptions }) => {
  const { t } = useTranslation('common');
  const filteredOptions = useMemo(
    () =>
      BOON_VALUES_OPTIONS.filter(
        ({ value: eachVal, label }) => value?.label === label || !selectedOptions.includes(eachVal)
      ),
    [selectedOptions]
  );

  return (
    <Select
      options={filteredOptions}
      value={value}
      onChange={onChange}
      placeholder={t('placeholders.selectObject')}
      handleAddCustomField={handleAddCustomField}
      isClearable
      components={{
        MenuList: CustomMenuList,
        Option: CustomOption,
        IndicatorSeparator: () => null,
        ClearIndicator: () => null,
      }}
      styles={customStyles}
      captureMenuScroll={false}
    />
  );
};

export default MappingSelect;
